var React = require( 'react' );
var createReactClass = require('create-react-class');
var DropDownListItem = require('./dropDownListItem.jsx');

var DropDownList = createReactClass({

    handleChange: function(){
        this.props.onChange && this.props.onChange(this.refs.selectInput.value);
    },

  render: function(){
    var list = this.props.list.map(function (listItem) {
      return (
          <DropDownListItem key={listItem.id} listItem={listItem} />
      );
    });

  return (
      <select onChange={this.handleChange} ref="selectInput" defaultValue={this.props.value}>
          {list}
      </select>
  );
  }
});

module.exports = DropDownList;



// WEBPACK FOOTER //
// ./src/common/routes/components/dropDownList.jsx